import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterOutlet } from '@angular/router';
import { EnhancedLoadingService } from './shared/services/enhanced-loading.service';

@Component({
  selector: 'app-root',
  imports: [AsyncPipe, MatProgressSpinnerModule, RouterOutlet],

  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  loadingService = inject(EnhancedLoadingService);

  title = 'datasafra-frontend';
}
